// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dsTL","name":"styles_name__13-zh","phone":"styles_phone__3PI4M"};